import { getFallbackValueIfNull } from 'owa-options-core';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import getStore from '../store/getStore';
export default function getOptions() {
    var savedOptions = getOptionsForFeature(OwsOptionsFeatureType.GdprAdsPrefs);
    var options = getStore();
    return {
        allowAccess: getFallbackValueIfNull(options.allowAccess, savedOptions.allowStorageAndAccess),
        allowAdSelection: getFallbackValueIfNull(options.allowAdSelection, savedOptions.allowAdSelectionDeliveryReporting),
        allowContentSelection: getFallbackValueIfNull(options.allowContentSelection, savedOptions.allowContentSelectionDeliveryReporting),
        allowPersonalization: getFallbackValueIfNull(options.allowPersonalization, savedOptions.allowPersonalization),
        allowMeasurement: getFallbackValueIfNull(options.allowMeasurement, savedOptions.allowMeasurement),
    };
}
//# sourceMappingURL=getOptions.js.map